<template>
  <b-form autocomplete="off">
    <b-form-row>
      <b-col cols="12" md="5">
        <b-form-group label-cols="3">
          <template v-slot:label>ĐT di động</template>
          <b-form-input v-model="thong_tin_lien_he.dtdidong"  :disabled="!hoso_update"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6"  class="form-inline" v-if="item" align-self="start">
        <div style="flex-grow: 1" />        
        <button class="btn btn-info" @click.prevent="updateItem" v-if="hoso_update"> <i class="fas fa-save mr-2"></i>Lưu thông tin liên hệ</button>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="5">
        <b-form-group>
          <template v-slot:label>
            <b>Hộ khẩu thường trú</b>
          </template>
        </b-form-group>
      </b-col>
      <b-col cols="0" md="1" />
      <b-col cols="12" md="5">
        <b-form-group>
          <template v-slot:label>
            <div class="form-inline">
              <b class="mr-4">Chỗ ở hiện nay</b>
              <b-form-checkbox v-model="cbx_hien_nay_giong_ho_khau" @change="copySlot">Giống hộ khẩu thường trú</b-form-checkbox>
            </div>
          </template>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" md="5">
        <b-form-group label-cols="3">
          <template v-slot:label>
            Thành phố
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_tinhthanhpho" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hokhau_tinhthanhpho_selected"                            
            placeholder
            track-by="id"
            label="name"
            selectedLabel="Đang chọn"
            select-label="Enter để chọn"
            deselectLabel="Enter để xóa"
            :searchable="true"                            
            :options="provinces"
            @select="unlockDistrict"
            @remove="lockDistrictAndWard">
          </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Quận/Huyện
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_quanhuyen" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
              v-model="hokhau_quanhuyen_selected"                            
              placeholder
              track-by="id"
              label="name"
              selectedLabel="Đang chọn"
              select-label="Enter để chọn"
              deselectLabel="Enter để xóa"
              :searchable="true"                            
              :options="districts"
              @select="unlockWard"
              @remove="lockWard"
              :disabled="!districtEnabled">
          </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Xã/Phường
          </template>  
          <!-- <b-form-input v-model="thong_tin_lien_he.hokhau_xaphuong" :disabled="!hoso_update" ></b-form-input>         -->
          <multiselect
            v-model="hokhau_xaphuong_selected"                            
            placeholder
            track-by="id"
            label="name"
            selectedLabel="Đang chọn"
            select-label="Enter để chọn"
            deselectLabel="Enter để xóa"
            :searchable="true"                            
            :options="wards"                            
            :disabled="!wardEnabled">
        </multiselect>
        </b-form-group>  
        <b-form-group label-cols="3">
          <template v-slot:label>
            Số nhà, đường
          </template>  
          <b-form-input v-model="thong_tin_lien_he.hokhau_sonha"></b-form-input>        
        </b-form-group>  
      </b-col>
      <b-col cols="0" md="1" />
      <b-col cols="12" md="5">
        <b-form-group label-cols="3">
          <template v-slot:label>
            Thành phố
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_tinhthanhpho" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hiennay_tinhthanhpho_selected"                            
            placeholder
            track-by="id"
            label="name"
            selectedLabel="Đang chọn"
            select-label="Enter để chọn"
            deselectLabel="Enter để xóa"
            :searchable="true"                            
            :options="provinces"
            @select="unlockDistrict_hiennay"
            @remove="lockDistrictAndWard_hiennay"
            :disabled="cbx_hien_nay_giong_ho_khau">
        </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Quận/Huyện
          </template>
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_quanhuyen" :disabled="!hoso_update" ></b-form-input> -->
          <multiselect
            v-model="hiennay_quanhuyen_selected"                            
            placeholder
            track-by="id"
            label="name"
            selectedLabel="Đang chọn"
            select-label="Enter để chọn"
            deselectLabel="Enter để xóa"
            :searchable="true"                            
            :options="hiennay_districts"
            @select="unlockWard_hiennay"
            @remove="lockWard_hiennay"
            :disabled="!hiennay_districtEnabled || cbx_hien_nay_giong_ho_khau">
        </multiselect>
        </b-form-group>
        <b-form-group label-cols="3">
          <template v-slot:label>
            Xã/Phường
          </template>  
          <!-- <b-form-input v-model="thong_tin_lien_he.hiennay_xaphuong" :disabled="!hoso_update" ></b-form-input>         -->
          <multiselect
            v-model="hiennay_xaphuong_selected"                            
            placeholder
            track-by="id"
            label="name"
            selectedLabel="Đang chọn"
            select-label="Enter để chọn"
            deselectLabel="Enter để xóa"
            :searchable="true"                            
            :options="hiennay_wards"                            
            :disabled="!hiennay_wardEnabled || cbx_hien_nay_giong_ho_khau">
        </multiselect>
        </b-form-group>  
        <b-form-group label-cols="3">
          <template v-slot:label>
            Số nhà, đường
          </template>  
          <b-form-input v-model="thong_tin_lien_he.hiennay_sonha" :disabled="cbx_hien_nay_giong_ho_khau"></b-form-input>        
        </b-form-group>  
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "ThongTinLienHe",
  props: ["quanhes", "quoctichs", "item"],
  components: {
    Multiselect,
  },
  data() {
    return {
      thong_tin_lien_he: {
        id: 0,
        employeeid: 0,
        dtdidong: null,
        hokhau_tinhthanhpho: null,
        hokhau_quanhuyen: null,
        hokhau_xaphuong: null,
        hokhau_sonha: null,
        hiennay_tinhthanhpho: null,
        hiennay_quanhuyen: null,
        hiennay_xaphuong: null,
        hiennay_sonha: null,
      },

      provinces: [],
      districts: [],
      wards: [],
      
      districtEnabled: false,
      wardEnabled: false,

      hokhau_tinhthanhpho_selected: null,
      hokhau_quanhuyen_selected: null,
      hokhau_xaphuong_selected: null,

      hiennay_provinces: [],
      hiennay_districts: [],
      hiennay_wards: [],
      
      hiennay_provinceEnabled: false,
      hiennay_districtEnabled: false,
      hiennay_wardEnabled: false,
      hiennay_tinhthanhpho_selected: null,
      hiennay_quanhuyen_selected: null,
      hiennay_xaphuong_selected: null,

      cbx_hien_nay_giong_ho_khau: false,
    };
  },
  computed: {        
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    initData() {
      axios
        .get(`/api/employeecontact/${this.item.id}`)
        .then((response) => {
          this.thong_tin_lien_he = response.data;
          
          axios.get("/api/location/province").then((res) => {
            this.provinces = res.data;
            this.hokhau_tinhthanhpho_selected = this.provinces.find(x => x.id == this.thong_tin_lien_he.hokhau_tinhthanhpho);
          });

          if (this.thong_tin_lien_he.hokhau_tinhthanhpho != null) {
            axios.get(`/api/location/district/${this.thong_tin_lien_he.hokhau_tinhthanhpho}`).then((res) => {
              this.districts = res.data;
              this.hokhau_quanhuyen_selected = this.districts.find(x => x.id == this.thong_tin_lien_he.hokhau_quanhuyen);            
            });            

            this.districtEnabled = true;
          }

          if (this.thong_tin_lien_he.hokhau_quanhuyen != null) {
            axios.get(`/api/location/ward/${this.thong_tin_lien_he.hokhau_quanhuyen}`).then((res) => {
              this.wards = res.data;
              this.hokhau_xaphuong_selected = this.wards.find(x => x.id == this.thong_tin_lien_he.hokhau_xaphuong);            
            });            

            this.wardEnabled = true;
          }

          axios.get("/api/location/province").then((res) => {
            this.hiennay_provinces = res.data;
            this.hiennay_tinhthanhpho_selected = this.hiennay_provinces.find(x => x.id == this.thong_tin_lien_he.hiennay_tinhthanhpho);
          });
          
          if (this.thong_tin_lien_he.hiennay_tinhthanhpho != null) {
            axios.get(`/api/location/district/${this.thong_tin_lien_he.hiennay_tinhthanhpho}`).then((res) => {
              this.hiennay_districts = res.data;
              this.hiennay_quanhuyen_selected = this.hiennay_districts.find(x => x.id == this.thong_tin_lien_he.hiennay_quanhuyen);            
            });            

            this.hiennay_districtEnabled = true;
          }

          if (this.thong_tin_lien_he.hiennay_quanhuyen != null) {
            axios.get(`/api/location/ward/${this.thong_tin_lien_he.hiennay_quanhuyen}`).then((res) => {
              this.hiennay_wards = res.data;
              this.hiennay_xaphuong_selected = this.hiennay_wards.find(x => x.id == this.thong_tin_lien_he.hiennay_xaphuong);                          
            });            

            this.hiennay_wardEnabled = true;
          }
          
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openModal(modalType) {
      this.$emit("openModal", modalType);
    },
    updateItem() {
      if (this.hokhau_tinhthanhpho_selected != null) this.thong_tin_lien_he.hokhau_tinhthanhpho = "" + this.hokhau_tinhthanhpho_selected.id; 
      if (this.hokhau_quanhuyen_selected != null) this.thong_tin_lien_he.hokhau_quanhuyen    = "" + this.hokhau_quanhuyen_selected.id;
      if (this.hokhau_xaphuong_selected != null)  this.thong_tin_lien_he.hokhau_xaphuong     = "" + this.hokhau_xaphuong_selected.id;

      if (this.hiennay_tinhthanhpho_selected != null) this.thong_tin_lien_he.hiennay_tinhthanhpho = "" + this.hiennay_tinhthanhpho_selected.id; 
      if (this.hiennay_quanhuyen_selected != null) this.thong_tin_lien_he.hiennay_quanhuyen    = "" + this.hiennay_quanhuyen_selected.id;
      if (this.hiennay_xaphuong_selected != null)  this.thong_tin_lien_he.hiennay_xaphuong     = "" + this.hiennay_xaphuong_selected.id;

      if (this.cbx_hien_nay_giong_ho_khau) this.thong_tin_lien_he.hiennay_tinhthanhpho = "copy";

      axios
        .put("/api/employeecontact", this.thong_tin_lien_he)
        .then((res) => {
          this.$toast.success("Cập nhật thành công !", "Thành công", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },

    unlockDistrict(city) {                   
      this.hokhau_quanhuyen_selected = null;      
      this.lockWard();

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {          
          this.districts = res.data;
          this.districtEnabled = true;
        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    

    unlockWard(district) {        
      this.hokhau_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {          
          this.wards = res.data;
          this.wardEnabled = true;
        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });     
    },

    lockDistrictAndWard() {      
      this.hokhau_quanhuyen_selected = null;      
      this.hokhau_xaphuong_selected = null;
      this.districtEnabled = false;
      this.wardEnabled = false;
    },
    
    lockWard() {
      this.hokhau_xaphuong_selected = null;
      this.wardEnabled = false;
    },

    unlockDistrict_hiennay(city) {                   
      this.hiennay_quanhuyen_selected = null;      
      this.lockWard_hiennay();

      axios
        .get(`/api/location/district/${city.id}`)
        .then((res) => {          
          this.hiennay_districts = res.data;
          this.hiennay_districtEnabled = true;
        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    

    unlockWard_hiennay(district) {        
      this.hiennay_xaphuong_selected = null;
      axios
        .get(`/api/location/ward/${district.id}`)
        .then((res) => {          
          this.hiennay_wards = res.data;
          this.hiennay_wardEnabled = true;
        })
        .catch((err) => {
            this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });     
    },

    lockDistrictAndWard_hiennay() {      
      this.hiennay_quanhuyen_selected = null;      
      this.hiennay_xaphuong_selected = null;
      this.hiennay_districtEnabled = false;
      this.hiennay_wardEnabled = false;
    },
    
    lockWard_hiennay() {
      this.hiennay_xaphuong_selected = null;
      this.hiennay_wardEnabled = false;
    },

    copySlot() {
      if (!this.cbx_hien_nay_giong_ho_khau) {
        this.hiennay_tinhthanhpho_selected = this.hokhau_tinhthanhpho_selected;
        this.hiennay_quanhuyen_selected = this.hokhau_quanhuyen_selected;
        this.hiennay_xaphuong_selected = this.hokhau_xaphuong_selected;
        this.thong_tin_lien_he.hiennay_sonha = this.thong_tin_lien_he.hokhau_sonha;
        
      }
      else {
        this.hiennay_tinhthanhpho_selected = null;
        this.hiennay_quanhuyen_selected = null;
        this.hiennay_xaphuong_selected = null;
        this.thong_tin_lien_he.hiennay_sonha = null;
      }
    }

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>